/** obfuscate forbiden strings */
function getForbidenStringDY() {
  return `${'dy'}${'ni'}${'nno'}`
}

function getForbidenStringDT() {
  return `${'dy'}${'na'}${'tech'}`
}

/** qs turns repeated params into arrays and bracketed params into objects.
 *  Reduce any such value to a single usable string. */
function firstValue(value) {
  if (Array.isArray(value)) {
    return firstValue(value[0])
  }
  if (typeof value === 'string') {
    return value
  }
  return undefined
}

/** Turn a `line` / `sitePhone` value into a phone number with the given parser, or
 *  undefined when it cannot produce a usable one. The length check matters: strings
 *  like '123' and '00000000000' parse into a truthy but nonsense number.
 *  isPossible() rather than isValid() avoids rejecting a real, newly provisioned
 *  line on stale validation metadata.
 *
 *  The parser is injected so this module stays dependency free — requiring
 *  libphonenumber-js here would pull the whole package into the client bundle. */
function parseSitePhone(parsePhoneNumberFromString, value) {
  const parsed = parsePhoneNumberFromString(`${firstValue(value) || ''}`, 'US')
  return parsed && parsed.isPossible() ? parsed : undefined
}

module.exports = { getForbidenStringDY, getForbidenStringDT, firstValue, parseSitePhone }
